import { PersonBasicData } from "~/models";

export function personToDropdown(person: PersonBasicData) {
  const firstName = person?.firstName || person?.id;
  const name = `${firstName} ${person?.lastName || "-"}`;

  return { value: person?.id, label: name };
}
